import type { CsatTriggerPointStepComponent } from 'api/types';
import { useAppDispatch, useAppSelector } from 'hooks';
import { useEffect } from 'react';
import { selectCsatStates, setCsatStatesByKey } from 'reducers/workflows';
import type React from 'react';
import { selectCsatConfigRevamped } from 'reducers/config';
import { selectNextStepId } from 'reducers/workflows/index';
import { FAKE_AUTOFLOWS_STEP_ID } from 'components/App/consts';

interface CsatTriggerPointStepProps {
  setStepSent: (query?: string) => void;
  widgetComponent: CsatTriggerPointStepComponent;
}

const CsatTriggerPointStep: React.FC<
  React.PropsWithChildren<CsatTriggerPointStepProps>
> = ({ setStepSent, widgetComponent }) => {
  const dispatch = useAppDispatch();
  const nextStepId = useAppSelector(selectNextStepId);
  const csatStates = useAppSelector(selectCsatStates);
  const csatConfig = useAppSelector(selectCsatConfigRevamped);
  const { hasSubmitted } = csatStates;
  const isSent = !!widgetComponent.isSent;

  useEffect(() => {
    if (!csatConfig?.is_enabled) {
      return;
    }

    if (hasSubmitted || isSent) {
      return;
    }
    setStepSent();

    dispatch(
      setCsatStatesByKey({
        /**
         * if we're inside an autoflow and encountered a CSAT trigger point step,
         * don't try to resume from it since it's not a input required step in autoflow
         */
        actionToExecuteAfterCsatDismiss:
          nextStepId === FAKE_AUTOFLOWS_STEP_ID
            ? null
            : 'resume-from-trigger-point',
        isCsatVisible: true,
        triggeredFrom: 'csat-trigger-point',
      }),
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps -- we only need this to be executed once
  }, [dispatch]);

  return null;
};

export default CsatTriggerPointStep;
